module.exports = __webpack_public_path__ + "img/mail.7cec98e3.svg";